import { Capacitor } from "@capacitor/core";
import { isPlatform } from "@ionic/react";

export function isIOSApp() {
    return isPlatform("ios") && Capacitor.isNativePlatform();
}
